<template>
    <card-list-item no-cursor @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-money-check-alt fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title"><strong>{{referral.calc | currency}}</strong> <span v-if="referral.method === 'percent'">({{referral.value}}%)</span> for <strong>{{referral.type | capitalize}}</strong> payout</div>
            <div class="meta mt-2"><i class="fas fa-user mr-2 fa-fw"></i><strong>{{referral.firstname}} {{referral.lastname}}</strong></div>
            <div class="meta mt-1"><i class="fas fa-calendar-alt mr-2 fa-fw"></i>{{referral.enrollDate | moment('MMM Do, YYYY')}}</div>
            <!-- Payment plan details (only for non-cart enrollments) -->
            <div class="meta mt-1" v-if="!referral.isCartEnrollment"><i class="fas fa-money-check-alt mr-2 fa-fw"></i><strong>{{referral.total | currency}}</strong> at <strong>{{referral.monthly | currency}}/mo</strong> for <strong>{{referral.term}}</strong> month<span v-if="referral.term !== 1">s</span>, starting <strong>{{referral.defer | moment('MMM Do, YYYY')}}</strong></div>
            <!-- Cart enrollment info -->
            <div class="meta mt-1 green" v-else><i class="fas fa-shopping-cart mr-2 fa-fw"></i><strong>Cart Purchase</strong> - <strong>{{referral.totalPaid | currency}}</strong> paid in full</div>
            <!-- Payment progress (only for payment plans, super users) -->
            <div v-if="currentUser.isSuper && !referral.isCartEnrollment" class="meta mt-1" :class="{'orange': referral.plan_paid < referral.total, 'green': referral.plan_paid >= referral.total}">
                <i class="fas mr-2 fa-fw" :class="{'fa-ban': referral.plan_paid < referral.total, 'fa-check': referral.plan_paid >= referral.total}"></i><strong>{{referral.plan_paid | currency}}</strong> paid ({{ Math.ceil((referral.plan_paid / referral.total*100)) }}%), <strong>{{referral.total - referral.plan_paid | currency}}</strong> remaining<br>
                <b-progress
                    :type="(referral.plan_paid < referral.total) ? 'is-warning' : 'is-success'"
                    :value="Math.ceil((referral.plan_paid / referral.total*100))"
                    size="is-small"
                    class="ml-5 mt-1 mb-3 mr-6"
                ></b-progress>
            </div>
            <!-- Contract/payment status -->
            <div class="meta mt-1 mb-2 green" v-if="referral.isCartEnrollment"><i class="fas fa-check mr-2 fa-fw"></i><strong>Paid in Full</strong></div>
            <div class="meta mt-1 mb-2 red" v-else-if="!referral.contractFax"><i class="fas fa-ban mr-2 fa-fw"></i><strong>Contract NOT Signed</strong></div>
            <div class="meta mt-1 mb-2 green" v-else><i class="fas fa-check mr-2 fa-fw"></i><strong>Contract Signed</strong></div>
        </template>
        <template v-slot:status v-if="currentUser.isSuper">
            <div class="stats">
                <span class="stat"><b-switch :true-value="1" :false-value="0" v-model="referral.toggle" :disabled="!referral.isCartEnrollment && (!referral.contractFax || (referral.term === 1 && referral.plan_paid === 0))"/></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="ID">{{referral.id}}</data-row>
                    <data-row mini title="Enroll Date">{{referral.enrollDate | moment('MMM Do, YYYY h:mm:ss A')}}</data-row>
                    <data-row mini title="Defer Date" v-if="referral.defer">{{referral.defer | moment('MMM Do, YYYY')}}</data-row>
                    <data-row mini title="Sale Type">{{referral.sale_type || 'plan'}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    import { mapGetters } from 'vuex';

    export default {
        name: 'ResellerReferralTile',
        components: {CardListItem, DataRow, Toolbar},
        computed: {
            ...mapGetters(['currentUser'])
        },
        props: {
            referral: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;

        strong {
            color: inherit;
        }
    }

    .orange {
        color: #e57a04 !important;

        strong {
            color: #e57a04 !important;
        }
    }
    .red {
        color: red !important;

        strong {
            color: red !important;
        }
    }

    .green {
        color: green !important;

        strong {
            color: green !important;
        }
    }
</style>
